import { animate, style, transition, trigger } from '@angular/animations';
import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { v4 as uuidv4 } from 'uuid';
import { ToastMessage, ToastMessageWithHeader, ToastType } from './toast.dto';
import { ToastService } from './toast.service';

@Component({
  selector: 'app-toast',
  standalone: true,
  templateUrl: './toast.component.html',
  styleUrl: './toast.component.scss',
  imports: [CommonModule, RouterModule],
  animations: [
    trigger('toastAnimation', [
      transition(':enter', [style({ opacity: 0, transform: 'translateY(20px)' }), animate('0.5s ease-in-out', style({ opacity: 1, transform: 'translateY(0)' }))]),
      transition(':leave', [animate('0.5s ease-in-out', style({ opacity: 0, transform: 'translateY(-20px)' }))]),
    ]),
  ],
})
export class ToastComponent {
  toasts: (ToastMessage | ToastMessageWithHeader)[] = [];
  toastType: ToastType;

  constructor(private toastService: ToastService) {}

  ngOnInit(): void {
    this.toastService.toasts$.subscribe((toast) => {
      const data = {
        ...toast,
        _id: toast._id || uuidv4(),
      };
      this.toasts.push(data);

      setTimeout(() => this.removeToast(0), 3000);
    });
  }

  removeToast(index: number): void {
    this.toasts.splice(index, 1);
  }
}
